import { Avatar } from "@heroui/react";
import { CustomCheckbox } from "../shared";

const GroupMemberSelection = ({
  avatar,
  name,
  currentIndex,
  searchUserListing,
  setSearchUserListing,
  membersList,
  setMembersList,
  isSearchActive,
}) => {
  const handleCheckboxChange = (checked) => {
    const itemId = isSearchActive
      ? searchUserListing[currentIndex]?.id
      : membersList[currentIndex]?.id;

    // Update All Users
    setMembersList((prev) => {
      const updatedList = [...prev];
      const targetIndex = updatedList.findIndex((user) => user.id === itemId);
      if (targetIndex !== -1) {
        updatedList[targetIndex] = {
          ...updatedList[targetIndex],
          selected: checked,
        };
      }
      return updatedList;
    });

    // Update Search Users (if active)
    if (isSearchActive) {
      setSearchUserListing((prev) => {
        const updatedList = [...prev];
        const targetIndex = updatedList.findIndex((user) => user.id === itemId);
        if (targetIndex !== -1) {
          updatedList[targetIndex] = {
            ...updatedList[targetIndex],
            selected: checked,
          };
        }
        return updatedList;
      });
    }
  };

  const isChecked = isSearchActive
    ? searchUserListing[currentIndex]?.selected
    : membersList[currentIndex]?.selected;

  return (
    <div
      className="flex items-center gap-3 p-4 hover:bg-surface cursor-pointer"
      onClick={() => {
        handleCheckboxChange(!isChecked);
      }}
      role="button"
      tabIndex={0}
      aria-pressed={!!isChecked}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleCheckboxChange(!isChecked);
        }
      }}
    >
      <CustomCheckbox
        checked={isChecked}
        onChange={(checked) => handleCheckboxChange(checked)}
      />
      <div className="relative flex items-center gap-3">
        <Avatar
          src={avatar}
          classNames={{
            base: "bg-mediumgrey/30",
            icon: "text-black/60",
          }}
        />
        <h3 className="font-medium">{name}</h3>
      </div>
    </div>
  );
};

export default GroupMemberSelection;
